import { Component, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

type ProfileActivityConfig = [string, number];

@Component({
  selector: 'dgx-profile-activity',
  templateUrl: './profile-activity.component.html',
  styleUrls: ['./profile-activity.component.scss'],
})
export class ProfileActivity implements OnInit {
  @Input() public skillsCount: number = 0;
  @Input() public skillRatingsCount: number = 0;
  @Input() public experiencesCount: number = 0;
  @Input() public achievementsCount: number = 0;
  @Input() public learningsCount: number = 0;

  public config: ProfileActivityConfig[];
  // Local
  public i18n = this.translate.instant([
    'Core_Activity',
    'Core_Skills',
    'Core_Ratings',
    'Core_ExperiencesDisplayName',
    'Core_Achievements',
    'dgProfileOverview_LearningTitle',
  ]);

  constructor(private translate: TranslateService) {}

  public ngOnInit() {
    this.config = [
      [this.i18n.Core_Skills, this.skillsCount],
      [this.i18n.Core_Ratings, this.skillRatingsCount],
      [this.i18n.Core_ExperiencesDisplayName, this.experiencesCount],
      [this.i18n.Core_Achievements, this.achievementsCount],
      [this.i18n.dgProfileOverview_LearningTitle, this.learningsCount],
    ];
  }
}
